var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsUpgrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 96 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280 896v-80h400v80H280Zm160-160V409L336 512l-56-56 200-200 200 200-56 56-104-103v327h-80Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsUpgrade);
export default __webpack_public_path__ + "static/media/icons-upgrade.807206a5e682f8b33c00707a1a5822bf.svg";
export { ForwardRef as ReactComponent };